/* eslint-env browser */
import { KngLegalActeForm } from './kng-legal-acte-form.webcomponent.js';
import './kng-legal-acte-form.style.js';

export { KngLegalActeForm };

export function registerLegalActeForm() {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!window.customElements.get('kng-legal-acte-form')) {
    window.customElements.define('kng-legal-acte-form', KngLegalActeForm);
  }

  if (!window.customElements.get('sl-legal-acte-form')) {
    class SlLegalActeForm extends KngLegalActeForm {}
    window.customElements.define('sl-legal-acte-form', SlLegalActeForm);
  }

  window.KngLegalActeForm = KngLegalActeForm;
  window.registerLegalActeForm = registerLegalActeForm;
  return true;
}

if (typeof window !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', registerLegalActeForm, { once: true });
  } else {
    registerLegalActeForm();
  }
}
